







































































































































import Vue from 'vue'
import { fetchWalletById, fetchCurrenciesList, addWalletBalance, deductWalletBalance } from '../services/currencies-client'
import { WalletsListItemData, CurrenciesListData } from '../types'
import WalletsDetails from '../components/WalletsDetails.vue'
import CurrenciesForm from '../components/CurrenciesForm.vue'
import AppBackToListButton from '@morpheus/utils/admin-vue/components/AppBackToListButton.vue'

export default Vue.extend({
  name: 'WalletsShow',
  components: {
    WalletsDetails,
    CurrenciesForm,
    AppBackToListButton
  },
  props: {
    id: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      wallet: {} as any,
      showDetails: false,
      dialog: false,
      currencies: {} as any,
      componentKey: 0,
      currenciesListArray: [] as Array<any>,
      currenciesList: {},
      selectedCurrencies: [] as Array<string>,
      actionName: ''
    }
  },
  computed: {
    isSaveActionDisabled ():boolean {
      return this.currencies.hasOwnProperty('') || !Object.keys(this.currencies).length
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      this.$store.commit('global/setLoading', true)
      const self = this
      await fetchWalletById(self.id)
        .then((wallet: WalletsListItemData) => {
          self.wallet = wallet
          self.showDetails = true
        })
        .catch(error => {
          self.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          self.$store.commit('global/setLoading', false)
        })
      await fetchCurrenciesList()
        .then((currenciesList: CurrenciesListData) => {
          self.currenciesList = currenciesList
          Object.keys(self.currenciesList).map(key => {
            self.currenciesListArray.push({ 'text': key, 'value': key })
          })
        })
        .catch(error => {
          self.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          self.$store.commit('global/setLoading', false)
        })
    },
    onUpdatePriceCurrencies (amount: number, currency: string, oldCurrency: string) {
      const currencies = Object.assign({}, this.currencies)
      currencies[currency] = amount
      if (currencies.hasOwnProperty(oldCurrency)) {
        delete currencies[oldCurrency]
      }
      if (oldCurrency) {
        this.selectedCurrencies.splice(this.selectedCurrencies.indexOf(oldCurrency), 1)
      }
      if (this.selectedCurrencies.indexOf(currency) === -1) {
        this.selectedCurrencies.push(currency)
      }
      delete currencies['']
      if (currency) {
        this.currencies = currencies
      }
    },
    addCurrency () {
      // Use this method to achieve reactivity for object properties.
      // https://vuejs.org/v2/guide/reactivity.html
      this.currencies = Object.assign({}, this.currencies, { '': 0 })
    },
    removeCurrency (currency: string) {
      Vue.delete(this.currencies, currency)
      this.selectedCurrencies = this.selectedCurrencies.filter(e => e !== currency)
      this.componentKey += 1
    },
    openDialogForAdd () {
      this.dialog = true
      this.actionName = 'add'
    },
    openDialogForDeduct () {
      this.dialog = true
      this.actionName = 'deduct'
    },
    addBalance () {
      addWalletBalance({ currencies: this.currencies }, this.id)
        .then(() => {
          this.fetchData()
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
      this.hideModal()
    },
    deductBalance () {
      deductWalletBalance({ currencies: this.currencies }, this.id)
        .then(() => {
          this.fetchData()
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
      this.hideModal()
    },
    hideModal () {
      this.actionName = ''
      this.selectedCurrencies = []
      this.currencies = {}
      this.dialog = false
    }
  }
})
